// src/components/store/sections/blog-posts/BlogV30BentodigestIndigoPulse.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV30BentodigestIndigoPulse(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={30}
      archKey="bento_digest"
      archLabel="Bento Digest Tiles"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
